import './WindowEffect.scss'

type displayType = 'flex' | 'block';

export class WindowEffect {
    
    private readonly root: HTMLDivElement;
    static readonly CLASS_NAME_SHOW = 'window-effect--show';
    static readonly CLASS_NAME_HIDE = 'window-effect--hide';
    private styleDisplay: displayType;
    
    constructor(root: HTMLDivElement, styleDisplay: displayType) {
        this.root = root
        this.styleDisplay = styleDisplay;
    }
    
    public show() {
        this.root.classList.remove(WindowEffect.CLASS_NAME_HIDE);
        this.root.classList.add(WindowEffect.CLASS_NAME_SHOW)
        this.root.style.display = this.styleDisplay;
    }
    
    public hide() {
        this.root.classList.remove(WindowEffect.CLASS_NAME_SHOW);
        this.root.classList.add(WindowEffect.CLASS_NAME_HIDE)
        setTimeout(() => {
            this.root.style.display = 'none'
            this.root.classList.remove(WindowEffect.CLASS_NAME_HIDE);
        },300);
    }
    
}